import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from './styles';
import AirdropOrderPage from './components/AirdropOrderPage';
import AirdropHistoryPage from './components/AirdropHistoryPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<AirdropOrderPage />} />
          <Route path="/history" element={<AirdropHistoryPage />} />
          {/* 后续可以添加第三个页面的路由 */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;